import React from 'react';
import PropTypes from 'prop-types';

function Footer() {
  return <div></div>;
}

Footer.propTypes = {
  fluid: PropTypes.bool,
  white: PropTypes.bool
};

export default Footer;
